import React from "react";
import { Text, Box } from "@showitinc/showit-wc";
import Modal from "../../app2components/base/Modal/Modal";
import styles from "./DeleteFolderModal.module.css";

/**
 * Modal to confirm deletion of a site folder
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Callback when modal is closed
 * @param {Function} props.onConfirm - Callback when delete is confirmed
 * @param {string} props.folderName - Name of the folder being deleted
 * @param {boolean} [props.isEmpty=false] - Whether the folder is empty
 */
const DeleteFolderModal = ({ isOpen, onClose, onConfirm, folderName, isEmpty = false }) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Folder"
      size="small"
      secondaryButtonTitle="Cancel"
      secondaryButtonAction={onClose}
      primaryButtonTitle="Delete"
      primaryButtonAction={handleConfirm}
      primaryButtonVariant="destructive"
    >
      <div className={styles["modal-content"]}>
        <Text variant="header-2">
          Are you sure you want to delete <strong>{folderName}</strong>?
        </Text>
        <Box pt="3">
          <Text variant="body-1" className={styles["note-text"]}>
            {isEmpty 
              ? "This folder is empty and will be permanently deleted."
              : "Sites in this folder will be unassigned, but not deleted."
            }
          </Text>
        </Box>
      </div>
    </Modal>
  );
};

export default DeleteFolderModal;

